import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'
import type { Environment } from 'config/environment'

import { getFactorialData } from 'modules/core/lib/cookie'
import { isRumEnabledForCompany } from 'modules/core/lib/datadogRumUtils'

export default ({
  datadogLogsEnabled,
  datadogRumEnabled,
  datadogRumAllowedCompanyIds,
  datadogEnvironment,
  releaseVersion,
}: Environment) => {
  if (datadogLogsEnabled) {
    datadogLogs.init({
      clientToken: 'pubf8780e2aecab9d7f62aeccdc6115701a',
      service: 'factorial-frontend',
      version: releaseVersion,
      forwardErrorsToLogs: false,
      site: 'datadoghq.eu',
      env: datadogEnvironment,
      beforeSend: (log) => {
        // Filter out ValidationErrors
        if (log.message.includes('ValidationError')) {
          return false
        }

        // Remove Amplitude related logs
        if (log.message.includes('Amplitude Logger')) {
          return false
        }

        // discard aborted queries network errors
        if (log.http && log.http.status_code === 0) {
          return false
        }
      },
    })
  }

  const { companyId } = getFactorialData() || {}
  const isAllowedCompany = isRumEnabledForCompany(
    datadogEnvironment,
    datadogRumAllowedCompanyIds,
    companyId
  )

  if (datadogRumEnabled && isAllowedCompany) {
    datadogRum.init({
      applicationId: '46ad792e-ff19-4674-b4e9-bdb9c3c379ef',
      clientToken: 'pub267c9b1fc12083c62d128c5c84013bb0',
      site: 'datadoghq.eu',
      service: 'factorial-frontend',
      env: datadogEnvironment,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      version: releaseVersion,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    })
  }
}
